export default "__VITE_ASSET__CMQ7$r2A__"